import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {SelectEvent} from './types';
import css from './index.styl?inline';
import template from './index.jade';

export class Toggle extends Component<EmptyObj> {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      selected: `string`,
      size: {type: `string`, enum: [`medium`, `large`], default: `medium`},
      theme: {type: `string`, enum: [`tab-bar`, `segmented-controller`], default: `segmented-controller`},
      options: {type: `json`, description: `toggle options`, tsType: `ToggleOption[]`},
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,

      helpers: {
        selectOption: (value) => {
          this.selectOption(value);
        },

        // NOTE: querying slotted children for options is a deprecated method. Pass options via json attr.
        // attr changes always result in an update -> render.
        // if something changes the slotted children, the tab won't re-render causing all sorts of ui glitches.
        toggleOptions: () =>
          this.attr(`options`)
            ? this.attr(`options`)
            : Array.from(this.children)
                .filter((el) => el.tagName.toLowerCase() === `mp-toggle-option`)
                .map((el) => {
                  const icon = el.getAttribute(`icon`);
                  return {
                    disabled: this.isAttributeEnabled.call(el, `disabled`),
                    label: el.textContent,
                    value: el.getAttribute(`value`),
                    ...(icon ? {icon} : {}),
                  };
                }),
      },
    };
  }

  get value() {
    return this.attr(`selected`);
  }

  selectOption(value: string) {
    this.dispatchEvent(new CustomEvent(`select`, {detail: {selected: value}}) as SelectEvent);
  }
}

export const ToggleEl = defineAndMakeJsxFactory(`mp-toggle`, Toggle);
